<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th>Id</th>
          <th>Cliente Id</th>
          <th>Nome</th>
          <th>E-mail</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="contact in contacts" :key="contact.uid">
          <td>{{ contact.id }}</td>
          <td>{{ contact.clientId }}</td>
          <td>{{ contact.name }}</td>
          <td>{{ contact.email }}</td>
          <td>{{ contact.userType }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import { createColumnFilter } from '@/utils/dataTableFilters'

export default {
  name: 'ListContacts',

  props: {
    contacts: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListContacts',
      },
      dateTimeSqlToDateTimeBR,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }

      const self = this

      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
        order: this.dataTable.order,
        initComplete() {
          const api = this.api()
          const thead = window.$(`#${self.dataTable.id} thead`)

          const filterConfig = [
            { index: 0, type: 'input' },
            { index: 1, type: 'input' },
            { index: 2, type: 'input' },
            { index: 3, type: 'input' },
            {
              index: 4,
              type: 'select',
              options: [
                { value: '', text: 'Selecione' },
                { value: 'CONTACT', text: 'CONTACT' },
                { value: 'TECHNICIAN', text: 'TECHNICIAN' },
                { value: 'END_USER', text: 'END_USER' },
              ],
            },
          ]

          createColumnFilter(api, thead[0], filterConfig)
        },
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
